<template>
    <div class="guided-regulation-exemptions-field">
        <BFormGroup
            :label="translate('Component(ResearchReviewProcess):exemptions', 'Exemptions')"
            class="mb-0"
        >
            <v-select
                :value="value"
                :options="options"
                :multiple="true"
                :close-on-select="false"
                :taggable="supported"
                :push-tags="supported"
                :searchable="supported"
                :clearable="false"
                :create-option="createExemptionOption"
                :placeholder="supported ? placeholder : ''"
                @input="$emit('input', $event)"
            />
        </BFormGroup>

        <BAlert v-if="!supported && value.length" variant="light-warning" show class="mb-0 mt-75">
            <div class="alert-body">
                {{ translate(
                    'Component(ResearchReviewProcess):unsupported-regulation-exemptions',
                    'Exemptions are not supported for this regulation. Remove the existing exemptions.',
                ) }}
            </div>
        </BAlert>
    </div>
</template>

<script>
import {
    BAlert,
    BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    name: 'GuidedRegulationExemptionsField',
    components: {
        BAlert,
        BFormGroup,
        vSelect,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            default: () => [],
        },
        supported: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        placeholder() {
            return this.translate(
                'Component(ResearchReviewProcess):exemptions-placeholder',
                'Select or enter exemptions',
            )
        },
    },
    methods: {
        createExemptionOption(value) {
            return typeof value === 'string' ? value.trim() : value
        },
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>

<style lang="scss" scoped>
.guided-regulation-exemptions-field {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #ebe9f1;
}
</style>
